// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GigAssPrompt_wrapper__9ylBf"};